import React from 'react';

import styles from './fundProfileBannerStyles';

import Banner from 'buyside/components/presentation/Banner/banner';
import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';

import XMarkIcon from 'buyside/svgs/x_mark.svg';

import { COMMUNITY, ALLOCATOR } from 'buyside/util/fundProfileConstants';

const fundProfileText = {
  draft: (
    <span>
      Your Fund Profile is currently in draft mode and is not yet visible on the platform. You must
      publish in order to go live.
    </span>
  ),
  hidden: (
    <span>
      <strong>Your Fund Profile is currently in Hidden mode</strong> and is not visible on the
      platform. Please contact{' '}
      <strong>
        <a href="mailto:access@sumzero.com">access@sumzero.com</a>
      </strong>{' '}
      to reactivate your page.
    </span>
  ),
  pending: (
    <span>
      Your Fund Profile is currently under review and is not yet visible on the platform. Please
      contact{' '}
      <strong>
        <a href="mailto:support@sumzero.com">support@sumzero.com</a>
      </strong>{' '}
      if you have any questions.
    </span>
  )
};

const FundProfileBanner = ({ status, viewAsMode, viewingAs, toggleViewAsMode, viewAs }) => {
  if (viewAsMode) {
    return (
      <Banner>
        <span>Viewing this profile as a:</span>
        <select
          value={viewingAs}
          className={styles.viewAsSelect}
          onChange={e => viewAs(e.target.value)}
        >
          <option value={COMMUNITY}>General community member</option>
          <option value={ALLOCATOR}>Capital allocator</option>
        </select>
        <Button
          text="RETURN TO EDITING MODE"
          onClick={toggleViewAsMode}
          type={BUTTON_TYPES.LINK}
          icon={XMarkIcon}
          iconStyle={styles.returnIcon}
        />
      </Banner>
    );
  } else {
    return <div>{status !== 'active' && <Banner>{fundProfileText[status]}</Banner>}</div>;
  }
};

export default FundProfileBanner;
